import { render } from "./UserRow.vue?vue&type=template&id=1510d5c7&ts=true"
import script from "./UserRow.vue?vue&type=script&lang=ts"
export * from "./UserRow.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__